import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { identRoutes, routes, TEsignRoutesValues, TIdentRoutesValues, TRoutesValues } from '../../routing/routes';
import { updateDataStorageNew } from '../api/updateDataStorage/updateDataStorage';
import { getTransactionId } from '../common/data';

export const PERSIST_ON_PATHS = [
  '/form/4/coContractor',
  '/form/5',
  routes.creditCheckSuccess,
  routes.creditCheckPending,
  routes.creditCheckRejection,
  ...identRoutes,
] satisfies Array<`/form/4/coContractor` | `/form/${number}` | TRoutesValues | TIdentRoutesValues | TEsignRoutesValues>;

export const useSncPersistLocation = () => {
  const location = useLocation();

  useEffect(() => {
    if (PERSIST_ON_PATHS.some((p) => location.pathname.startsWith(p))) {
      if (!getTransactionId()) {
        // eslint-disable-next-line no-console
        console.error('Could not persist route.');
        return;
      }

      updateDataStorageNew(getTransactionId(), {
        custom: { lastVisitedLocation: location.pathname },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);
};
